"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppPaySystemWalletsLocksListCtl = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletsLocksListCtl, _super);
    function AppPaySystemWalletsLocksListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_wallet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet; });
        _this.dk_pool_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pool_tag; });
        _this.dk_wait_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wait_amount; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPaySystemWalletsLocksListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AppPaySystemWalletsLocksListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    AppPaySystemWalletsLocksListCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.ListInnerPayWalletLocksByPayWalletIdGet.exec({
            inner_pay_wallet_id: key
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    wallet: resp.list[i].wallet,
                    pool_tag: resp.list[i].pool_tag,
                    wait_amount: resp.list[i].wait_amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemWalletsLocksListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AppPaySystemWalletsLocksListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteInnerPayWalletLock.exec({ data: { inner_pay_wallet_lock_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AppPaySystemWalletsLocksListCtl;
}(BaseController_1.BaseController));
exports.AppPaySystemWalletsLocksListCtl = AppPaySystemWalletsLocksListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ctl/AppPaySystemWalletsLocksListCtl.ts
// module id = 1057
// module chunks = 0